"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Constants = {
    TokenRefreshUrlRegExp: /gb\/api\/v1\/token\/refresh$/,
    TokenKeys: {
        ACCESS_TOKEN: 'gb_access_token',
        REFRESH_TOKEN: 'gb_refresh_token',
        ACCESS_TOKEN_EXPIRATION: 'gb_access_token_exp'
    },
    HttpStatuses: {
        CANCELLED: -1,
        UNAUTHORIZED: 401
    },
    // You can view the strings that match this regex in this link https://regex101.com/r/J8m8bl/1
    CidrRegularExpression: /^(?=\d+\.\d+\.\d+\.\d+($|\/))(([1-9]?\d|1\d\d|2[0-4]\d|25[0-5])\.?){4}(\/([0-9]|[1-2][0-9]|3[0-2]))$/,
    RegionTag: 'r'
};
exports.default = Constants;
